import { Column } from "primereact/column";
import {
  DataTable,
  DataTablePageEvent,
  DataTableSortEvent,
} from "primereact/datatable";
import { configProps, ProductEntry } from "../../types";
import React, { useState } from "react";
import { useAppDispatch } from "../../redux/store";
import { Button } from "primereact/button";
import { addNewSlice } from "../../redux/slices/addNew";
import { ProductCreate } from "../../api";
import DeleteProduct from "./DeleteProduct";
import { HistoryDialog } from "../../components/HistoryDialog";
import { CommentsDialog } from "../../components/CommentsDialog";

type ProductsTableProps = {
  data: ProductEntry[];
  columns: configProps<"products">["columns"];
  isLoading: boolean;
  page: number;
  rowsPerPage: number;
  onPage: (e: DataTablePageEvent) => void;
  totalRecords?: number;
  sortField: string;
  sortOrder: number;
  onSort: (e: DataTableSortEvent) => void;
};

export default function ProductsTable({
  data,
  columns,
  isLoading,
  page,
  rowsPerPage,
  onPage,
  totalRecords,
  sortField,
  sortOrder,
  onSort,
}: ProductsTableProps) {
  const dispatch = useAppDispatch();

  const [selectedHistoryRow, setSelectedHistoryRow] =
    useState<ProductEntry | null>(null);
  const [selectedCommentsRow, setSelectedCommentsRow] =
    useState<ProductEntry | null>(null);

  const newClickBody = React.useCallback(
    (rowData: ProductEntry) => {
      return (
        <div className="flex-container">
          <Button
            size="small"
            icon="pi pi-pencil"
            text
            onClick={() => {
              dispatch(
                addNewSlice.actions.openAddNewDialog({
                  target: {
                    field: "product",
                    type: "product",
                    initialValues: {
                      id: rowData.id,
                      name: rowData.name,
                      sales_contract_template_id:
                        rowData.sales_contract_template_id,
                      purchase_contract_template_id:
                        rowData.purchase_contract_template_id,
                    } as Partial<ProductCreate>,
                  },
                }),
              );
            }}
          />
          <Button
            size="small"
            icon="pi pi-history"
            text
            onClick={(e) => {
              e.stopPropagation();
              setSelectedHistoryRow(rowData);
            }}
          />
          <Button
            size="small"
            className="wide"
            icon="pi pi-comment"
            text={rowData.commentsCount === 0}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedCommentsRow(rowData);
            }}
          />
          <DeleteProduct rowData={rowData} />
        </div>
      );
    },

    [dispatch],
  );
  return (
    <>
      <DataTable
        value={data}
        dataKey="id"
        size="small"
        lazy
        paginator
        rows={rowsPerPage}
        first={page * rowsPerPage}
        totalRecords={totalRecords}
        onPage={onPage}
        rowsPerPageOptions={[10, 25, 50, 100]}
        sortField={sortField}
        sortOrder={(sortOrder ?? 1) as 1 | -1}
        onSort={onSort}
        scrollable
        scrollHeight="75vh"
        emptyMessage={
          isLoading ? "Ładowanie towary..." : "Nie można znaleźć towarów!"
        }
      >
        {columns
          .filter((entry) => entry !== undefined)
          .map((entry) => {
            return (
              <Column
                key={entry.field}
                field={entry.field}
                header={entry.header}
                sortable={entry.sortable ?? false}
                body={entry.body}
              />
            );
          })}
        <Column className="icon-column" body={newClickBody} />
      </DataTable>
      <HistoryDialog<"products">
        rowData={selectedHistoryRow}
        onHide={() => setSelectedHistoryRow(null)}
        columns={columns}
      />
      <CommentsDialog<"products">
        rowData={selectedCommentsRow}
        onHide={() => setSelectedCommentsRow(null)}
        columns={columns}
      />
    </>
  );
}
